import { axiosGet } from '@/api/handlers';
import { ContractorPaymentUploaderTemplate } from '../projects/_models/contractor-payment-uploader';

export const fetchContractorPaymentUploaderTemplate = async (
  projectId: string,
) => {
  const templateData = await axiosGet(
    `/api/projects/${projectId}/contractor-payments/template-csv-upload/`,
  );
  return ContractorPaymentUploaderTemplate.parse(templateData);
};
